import { render, staticRenderFns } from "./ManageDepartments.vue?vue&type=template&id=9dbbd494&scoped=true"
import script from "./ManageDepartments.vue?vue&type=script&lang=js"
export * from "./ManageDepartments.vue?vue&type=script&lang=js"
import style0 from "./ManageDepartments.vue?vue&type=style&index=0&id=9dbbd494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbbd494",
  null
  
)

export default component.exports